import { useNetwork } from '@/presentation/context/network';
import Link from 'next/link';
import { useTranslations } from 'use-intl';
import { iconMap } from '../constants';
import Icon from '@/presentation/components/elements/Icon';
import { Page } from '../types';
import { SidebarHorizontalLinkIcon } from './SidebarHorizontalLinkIcon';

interface SidebarHorizontalLinkProps {
  page: Page;
  isActive: boolean;
}

export const sidebarHorizontalLinkClasses = (isActive: boolean) => {
  return `${
    isActive ? 'text-gray-800' : 'text-gray-400'
  } cursor-pointer p-2 flex-col min-w-[1rem] space-y-1 inline-flex items-center text-xs capitalize group transition-colors`;
};

export const SidebarHorizontalLink = ({
  page,
  isActive,
}: SidebarHorizontalLinkProps) => {
  const { slug: chain } = useNetwork();
  const t = useTranslations('Sidebar');

  return (
    <Link
      href={`/${chain}/${page.toLowerCase()}`}
      className={sidebarHorizontalLinkClasses(isActive)}
    >
      <SidebarHorizontalLinkIcon icon={iconMap[page]} isActive={isActive} />
      <span>{t(page)}</span>
    </Link>
  );
};

interface SidebarHorizontalCreateLinkProps {
  href: string;
  title: string;
}

export const SidebarHorizontalCreateLink = ({
  href,
  title,
}: SidebarHorizontalCreateLinkProps) => {
  return (
    <li>
      <Link
        href={href}
        className="p-2 text-base font-medium text-gray-800 block w-full hover:bg-gray-100 text-left cursor-pointer"
      >
        {title}
      </Link>
    </li>
  );
};
